import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36150fb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-tasks-page__content" }
const _hoisted_2 = { class: "user-tasks-page__block" }
const _hoisted_3 = { class: "user-tasks-page__data-user" }
const _hoisted_4 = { class: "user-tasks-page__data-user-name" }
const _hoisted_5 = { class: "user-tasks-page__filter-header" }
const _hoisted_6 = {
  key: 1,
  class: "user-tasks-page__main"
}
const _hoisted_7 = { class: "user-tasks-page__list" }
const _hoisted_8 = {
  key: 2,
  class: "user-tasks-page__no-find-tasks"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-tasks-page__no-find-tasks--title" }, "Тикеты не найдены", -1))

import TasksKanbanFilter from '@/components/tasks-kanban/components/TasksKanbanFilter.vue';
import TaskHeader from '@/pages/tasks-order-pages/components/task-header/task-header.vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPagination,
  TirPmScrollbar,
  TirPmTooltipElement,
} from 'tir-components';
import { computed, onMounted, ref } from 'vue';
import { RouterLink, useRouter } from 'vue-router';
import {
  PageRequestModel,
  PaginationRequestModel,
  PaginationResponseModel,
  ProjectModel,
  UserModel,
} from '@/models';
import { debounce } from 'tir-pm-debounce';
import ProjectTaskLi from '@/pages/tasks-order-pages/components/project-tasks/project-task-li.vue';
import { TaskDrawer, TaskDrawerSettingsModel, TasksKanbanFilterModel } from '@/components';
import { ArrowUturnLeftIcon, MagnifyingGlassIcon } from 'tir-style-system/icons/outline';
import { TaskViewElementEnum } from './enums';
import {
  GetProjectTasksRequestModel,
  OrderTaskModel,
  TaskColumnModel,
  TaskFilterModel,
  TaskSortingModel,
  TaskModel,
} from './models';
import { AdapterService } from './adapter-service';
import UserTasksSkeleton from './components/user-tasks-skeleton/user-tasks-skeleton.vue';

/**Параметры */
const DEFAULT_PAGE_STEP = 10;

/**Текущий исполнитель */

export default /*#__PURE__*/_defineComponent({
  __name: 'user-tasks-page',
  props: {
  /**ID выбранного юзера */
  userId: { type: Number, required: true },
  /**ID проекта */
  projectId: { type: Number, required: true },
},
  emits: ["add", "openTaskDrawer", "removeTask"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Роутер */
const router = useRouter();
/**адаптер */
const adapter = new AdapterService();

/**Колонки */
const columns: TaskColumnModel[] = [
  new TaskColumnModel({
    Type: TaskViewElementEnum.Namespace,
    Name: '',
    Width: '1.5rem',
    MinWidth: '1.5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Queue,
    Name: 'Очередь',
    Width: '13.375rem',
    MinWidth: '13.375rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Number,
    Name: '№',
    Width: '5rem',
    MinWidth: '5rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Name,
    Name: 'Название',
    Width: '50vw',
    MinWidth: '20rem',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Status,
    Name: 'Статус',
    Width: '5.1875rem',
    MinWidth: '5.1875rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Priority,
    Name: 'Приоритет',
    Width: '4rem',
    MinWidth: '4rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.Difficulty,
    Name: 'Сложность',
    Width: '2rem',
    MinWidth: '2rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.EstimateTime,
    Name: 't (оценка)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
  new TaskColumnModel({
    Type: TaskViewElementEnum.WorkTime,
    Name: 't (затрачено)',
    Width: '5rem',
    MinWidth: '5rem',
    Align: 'center',
  }),
];
/**Дефолтное кол-во элементов на странице */
const currentPerformer = ref<UserModel>();
/**Список задач */
const tasks = ref<TaskModel[]>([]);
/**Страница */
const pageResponse = ref<PaginationResponseModel<Array<TaskModel>>>();
/**Загрузка при сортировке */
const isLoadingSorting = ref(false);
/**Кол-во элементов на странице */
const pageStep = ref(DEFAULT_PAGE_STEP);
/**Ссылка на компонент шторки задач */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
/**Информация проекта */
const projectInfo = ref<ProjectModel>();
/**Данные сортировки */
const sortingData = ref(
  new TaskSortingModel({
    OrderById: true,
  }),
);
/**Загрузка */
const isLoading = ref<boolean>();
/**Фильтр */
const filter = ref(new TasksKanbanFilterModel());
/**Настройки видимости */
const viewSettings = ref([
  TaskViewElementEnum.Namespace,
  TaskViewElementEnum.Queue,
  TaskViewElementEnum.Name,
  TaskViewElementEnum.Number,
  TaskViewElementEnum.Status,
  TaskViewElementEnum.Priority,
  TaskViewElementEnum.EstimateTime,
  TaskViewElementEnum.WorkTime,
]);

/**Текущая страница */
const currentPageRequest = computed(() => {
  if (pageResponse.value)
    return new PaginationRequestModel({
      Skip: pageResponse.value.Size * (pageResponse.value.Current - 1),
      Take: pageStep.value,
    });
});
/**Кол-во страниц */
const pagesCount = computed(
  () => pageResponse.value && Math.ceil(pageResponse.value.Count / pageResponse.value.Size),
);

/**Получить информацию о юзере */
const getUserInfo = async () => {
  isLoading.value = true;
  const result = await adapter.getEmployee(props.userId);
  if (result.IsSuccess) {
    currentPerformer.value = result.Value;
  }
  isLoading.value = false;
};
/** Получить список задач */
const getTasks = async (page: PaginationRequestModel, clear?: boolean) => {
  isLoading.value = true;
  if (clear) tasks.value = [];

  const response = await adapter.getTasksByProjectId(
    new GetProjectTasksRequestModel({
      ProjectId: props.projectId,
      Filter: new TaskFilterModel({
        Performers: [props.userId],
        Search: filter.value.Search,
      }),
      Page: page,
      Sort: sortingData.value,
    }),
  );
  if (response.IsSuccess) {
    tasks.value = response?.Items || [];
    pageResponse.value = response;
  } else {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: response.ErrorMessage ?? 'Ошибка получения списка задач',
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
      }),
    );
  }
  isLoading.value = false;
  return response.IsSuccess;
};
/**Получить информацию проекта */
const getProjectInfo = async () => {
  const resp = await adapter.getProject(props.projectId);
  if (resp.IsSuccess) {
    projectInfo.value = resp.Value;
  }
};
const comeBack = () => {
  router.back();
};

/**Изменить кол-во элементов на странице */
const changePageStep = async (value: number) => {
  pageStep.value = value;
  await getTasks(
    new PaginationRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
};

/**Обновить текущую страницу */
const changeCurrentPage = async (value: number) => {
  if (!pageResponse.value) return;

  await getTasks(
    new PaginationRequestModel({
      Skip: pageResponse.value.Size * (value - 1),
      Take: pageStep.value,
    }),
  );
};

/**Обновить тип сортировки */
const updateSortData = async (data: TaskSortingModel) => {
  if (!currentPageRequest.value) return;
  isLoadingSorting.value = true;
  sortingData.value = new TaskSortingModel(data);
  await getTasks(currentPageRequest.value);
  isLoadingSorting.value = false;
};

/**Открыть шторку с задачей */
const openTaskDrawer = (taskId: number) => {
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'edit',
      TaskId: taskId,
    }),
  );
};

/**При поиске */
const onSearch = async () => {
  if (!currentPageRequest.value) return;

  await getTasks(currentPageRequest.value, true);
};

/**При поиске через debounce */
const debounceOnSearch = debounce(onSearch, 100);
const applyFilter = async () => {
  if (!currentPageRequest.value) return;

  await getTasks(currentPageRequest.value, true);
};

onMounted(async () => {
  await getProjectInfo();
  await getUserInfo();
  await getTasks(
    new PaginationRequestModel(
      new PageRequestModel({
        Skip: 0,
        Take: pageStep.value,
      }),
    ),
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).LinkState,
          size: _unref(TirPmButtonSizeEnum).Regular,
          onClick: comeBack
        }, {
          leftSlot: _withCtx(() => [
            _createVNode(_unref(ArrowUturnLeftIcon))
          ]),
          _: 1
        }, 8, ["variant", "size"]),
        _createVNode(_unref(TirPmIconView), {
          size: 24,
          isRounded: "",
          isBordered: false,
          colorCode: currentPerformer.value?.AvatarColor,
          imageLoadUrl: currentPerformer.value?.ImageUrl
        }, {
          mainSlot: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentPerformer.value?.LastName[0]) + _toDisplayString(currentPerformer.value?.FirstName[0]), 1)
          ]),
          _: 1
        }, 8, ["colorCode", "imageLoadUrl"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(currentPerformer.value?.LastName) + " " + _toDisplayString(currentPerformer.value?.FirstName) + " " + _toDisplayString(currentPerformer.value?.MiddleName) + ": все задачи по проекту: ", 1),
        _createVNode(_unref(TirPmTooltipElement), { width: "max-content" }, {
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(projectInfo.value?.Name), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(TirPmIconView), {
              size: 24,
              isRounded: "",
              isBordered: false,
              colorCode: projectInfo.value?.PreviewColor,
              imageLoadUrl: projectInfo.value?.ImageUrl
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(projectInfo.value?.Name[0]), 1)
              ]),
              _: 1
            }, 8, ["colorCode", "imageLoadUrl"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TasksKanbanFilter, {
          ref: "$tasksKanbanFilter",
          "view-elements": viewSettings.value,
          "onUpdate:viewElements": _cache[0] || (_cache[0] = ($event: any) => ((viewSettings).value = $event)),
          filter: filter.value,
          "onUpdate:filter": _cache[1] || (_cache[1] = ($event: any) => ((filter).value = $event)),
          isSortingAndGroupingHidden: "",
          isFilterHidden: "",
          tasks: tasks.value,
          projectId: +__props.projectId,
          onOnSearch: _unref(debounceOnSearch),
          onApplyFilter: applyFilter
        }, null, 8, ["view-elements", "filter", "tasks", "projectId", "onOnSearch"])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createBlock(UserTasksSkeleton, { key: 0 }))
        : _createCommentVNode("", true),
      (tasks.value?.length && !isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(TaskHeader, {
              class: "user-tasks-page__columns-header",
              monitoringPage: "",
              "sort-data": sortingData.value,
              columns: columns,
              "enable-sorting": true,
              "view-settings": viewSettings.value,
              "is-loading": isLoadingSorting.value,
              "onUpdate:sortData": updateSortData
            }, null, 8, ["sort-data", "view-settings", "is-loading"]),
            _createVNode(_unref(TirPmScrollbar), {
              class: "user-tasks-page__scrollbar",
              showOnHover: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task) => {
                    return (_openBlock(), _createBlock(ProjectTaskLi, {
                      monitoringPage: "",
                      monitoringTicketPage: "",
                      key: task.Id,
                      task: task,
                      columns: columns,
                      "view-settings": viewSettings.value,
                      onOpenTaskDrawer: _cache[2] || (_cache[2] = ($event: any) => (openTaskDrawer($event))),
                      onRemoveTask: changeCurrentPage
                    }, null, 8, ["task", "view-settings"]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!tasks.value?.length && !isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(TirPmIconView), {
              size: 80,
              isBordered: false
            }, {
              mainSlot: _withCtx(() => [
                _createVNode(_unref(MagnifyingGlassIcon))
              ]),
              _: 1
            }),
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (pageResponse.value?.Current && pagesCount.value)
        ? (_openBlock(), _createBlock(_unref(TirPmPagination), {
            key: 3,
            class: "user-tasks-page__paginator",
            showMoreElements: "",
            "model-value": pageResponse.value.Current,
            "range-size": 3,
            pages: pagesCount.value,
            options: [10, 20, 30, 40, 50, 100],
            "count-elements": pageStep.value,
            "onUpdate:countElements": changePageStep,
            "onUpdate:modelValue": changeCurrentPage
          }, null, 8, ["model-value", "pages", "count-elements"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(TaskDrawer), {
      ref_key: "$taskDrawer",
      ref: $taskDrawer,
      showCloseButton: false
    }, null, 512)
  ]))
}
}

})